<template>
  <div class="zusatz-wohnungen">
    <template v-for="(wohnung, index) in gfWohnungen">

      <div :key="'wohnung' + index"
           class="zusatz-wohnung bg-dimmed round-corners mt-4 py-4 ml-auto">
        <v-icon v-if="gfWohnungen.length > 1"
                class="delete-wohnung"
                @click="deleteWohnung(wohnung.key)">delete
        </v-icon>

        <v-row no-gutters
               class="flex-nowrap">

          <v-col cols="3">
            <div class="dmb-link pl-4">
              Wohneinheit {{ index + 1 }}
            </div>
          </v-col>

          <v-col cols="9">
            <v-row no-gutters class="flex-nowrap">
              <v-col col="6"
                     class="zusatz--column">

                <template v-if="!selectTarifAllowed || index !== 0">
                  <schublade-tooltip v-if="sb === '500'">500&nbsp;€</schublade-tooltip>
                  <div v-else class="primary--text">300&nbsp;€</div>
                </template>

                <v-select v-else
                          v-model="sb"
                          v-validate="'required'"
                          :error-messages="errors.collect('sb')"
                          :items="selectableSbs"
                          data-vv-as="Selbstbehalt Wohnung"
                          class="required pa-0"
                          name="sb"
                          @change="updateAllSbs" >
                  <template slot="item"
                            slot-scope="{ item }">
                    <schublade-tooltip v-if="item === '500'">500&nbsp;€</schublade-tooltip>
                    <div v-else>300&nbsp;€</div>
                  </template>
                  <template slot="selection"
                            slot-scope="{ item }">
                    <schublade-tooltip v-if="item === '500'">500&nbsp;€</schublade-tooltip>
                    <div v-else class="primary--text">300&nbsp;€</div>
                  </template>
                </v-select>

              </v-col>

              <v-col cols="6"
                     class="zusatz--column">
                <div class="selected--text">
                  {{ getPrice(wohnung.key) ? $helpers.toGermanFloatString(getPrice(wohnung.key)) + "&nbsp;€" : "" }}
                </div>
              </v-col>

            </v-row>
          </v-col>
        </v-row>

        <v-row no-gutters>

          <v-spacer />

          <v-col cols="9"
                 class="we-input-container">
            <v-text-field v-validate="'required|numeric|min_value:100|max_value:24000'"
                          :value="wohnung.bruttojahresmiete"
                          :error-messages="errors.collect('gwjahresbruttomiete' + index)"
                          :name="'gwjahresbruttomiete' + index"
                          data-vv-as="Jahresbruttomiete"
                          suffix=" €"
                          label="Jahresbruttomiete in €"
                          hint="inklusive Nebenkosten"
                          persistent-hint
                          class="we-input-field required mb-0 mt-4 px-0"
                          @input="debouncedUpdateWohnung($event, wohnung.key)" />
          </v-col>

        </v-row>

      </div>

    </template>
    <v-row no-gutters>
      <v-spacer/>
      <v-col cols="9">
        <add-button text="Wohneinheit hinzufügen"
                    @add="addWohnung">
        </add-button>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import KeyTranslator from "@/components/helper/keyTranslatorMixin";
import ValidationMixin from "@/components/helper/ValidationMixin";
import twowayBinding from "@/store/twowayBindingMixin";
import {RIGHTS} from "@/store/user";
import AddButton from "@/components/gewerberechner/AddButton";
import SchubladeTooltip from './SchubladeTooltip';
import { mapState } from 'vuex';
import debounce from 'lodash.debounce';

export default {
  name: "ZusatzWohnungen",
  components: { SchubladeTooltip, AddButton },
  mixins: [twowayBinding, ValidationMixin, KeyTranslator],
  props: {
    personRef: {
      type: String,
      required: true,
    },
    remove: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data: function () {
    return {
      sb: '300',
      selectableSbs: ['300', '500']
    };
  },
  computed: {
    ...mapState({
      wohnungen: state => state.gewerbe.wohnungen,
      zahlweise: state => state.gewerbe.vertrag.zahlweise
    }),
    gfWohnungen() {
      return this.wohnungen.filter(wohnung => wohnung.ref === this.personRef);
    },
    selectTarifAllowed() {
      return this.$store.getters.checkAuthorization(RIGHTS.TARIFSELECTION);
    }
  },
  created() {
    this.debouncedUpdateWohnung = debounce(this.updateWohnung, 1000);
  },
  mounted() {
    if (this.gfWohnungen.length === 0) {
      this.addWohnung();
    } else {
      // create Deckungen in store
      this.updateAllSbs();
    }
  },
  methods: {
    addWohnung() {
      if (this.gfWohnungen.length < 5) {
        this.$store.commit('gewerbeAddWohnung', { person: this.personRef });
      } else {
        this.$store.dispatch('gewerbeShowDirektionsanfrage', {
          label: 'Wohneinheiten pro Geschäftsführer',
          limit: 5
        });
      }

    },
    updateWohnung(value, key) {
      if (this.isValid(value)) {
        const sb = {
          gewerbe: null,
          privat: this.sb
        };
        this.$store.dispatch('gewerbeUpdateWohnung', { person: this.personRef, wohnung: key, bruttojahresmiete: value, sb });
      }
      else if (value > 24000) {
        this.$store.dispatch('gewerbeShowDirektionsanfrage', {
          label: 'Jahresbruttomiete für eine Wohneinheit',
          limit: '24.000 €'
        });
      }
    },
    updateAllSbs() {
      const sb = {
        gewerbe: null,
        privat: this.sb
      };
      this.$store.dispatch('gewerbeUpdateWohnungen', { person: this.personRef, sb });
    },
    deleteWohnung(key) {
      this.$store.dispatch('gewerbeRemoveWohnung', { person: this.personRef, wohnung: key });
    },
    getPrice(key) {
      const deckung = this.$store.getters.gewerbeDeckung(this.personRef, 'SPEZ-PRIVVM', null, key);
      return deckung ? deckung.praemie[`z${this.zahlweise}`] : 0;
    },
    isValid(bjm) {
      return !!bjm && !isNaN(+bjm) && bjm >= 100 && bjm <= 24000;
    }
  }
};
</script>

<style>
.zusatz-wohnungen .zusatz-wohnung {
  position: relative;
  max-width: 510px;
  font-size: 16px;
}

.zusatz-wohnungen .delete-wohnung {
  position: absolute;
  top: 8px;
  right: 8px;
  cursor: pointer;
}

.zusatz-wohnungen .delete-wohnung:focus:after {
  background: none !important; /* animation gets stuck in vuetify 2 - so remove it*/
}

.zusatz-wohnungen .we-input-container {
  position: relative;
  display: flex;
  justify-content: flex-end;
  margin-right: 48px;
}

.zusatz-wohnungen .we-input-field {
  max-width: 60% !important;
}

.zusatz-wohnungen .we-input-field .v-messages.error--text {
  background-color: #f5f5f5;
  z-index: 10;
}

.zusatz-wohnungen .we-input-field input {
  text-align: right;
}

.zusatz-wohnungen .zusatz--column .v-select {
  padding: 0 !important;
  max-width: 80px !important;
  margin: -3px -40px 0 auto;
}

</style>


